<template minapp='mpx' xlang='wxml'>
  <es-card layout="{{['header']}}" custom-header='es-content__miniapp_card_header' custom-body='es-content__miniapp_card_body'>
    <view slot='header' class="child-card-title">
      <view>儿童购票说明</view>
      <view class="child-card-more" bindtap="jumpToComment">更多说明<es-icon size="16" class="es-content__name-info" name="angle-right" color="#212121"/></view>
    </view>
    <view class="child-card-list">
      <view wx:for="{{childList}}" class="child-card-item">
        <view wx:if="{{item.type === 'text'}}" class="child-card-text" >
          <text wx:for="{{item.value}}" wx:for-item="textItem" class="{{textItem.highLight ? 'child-card-text-highlight' : ''}}">{{textItem.text}}</text>
        </view>
        <view wx:if="{{item.type === 'table'}}" class="child-card-table">
          <view wx:for="{{item.value}}" wx:for-item="tItem" class="child-card-table-item {{index > 0 ? 'child-card-tr' : 'child-card-th'}}">
            <view wx:for="{{tItem}}" wx:for-item="vItem" class="child-card-vItem">
              {{vItem}}
            </view>
          </view>
        </view>
      </view>
    </view>
  </es-card>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { innerRouter, pagePath } from "@/common/jump";
  createComponent({
    classes: [],
    data: {
      childList: [
        {
          type: 'text',
          value: [{
            text: '需要凭儿童本人身份证件实名购票'
          }]
        },
        {
          type: 'table',
          value: [
            [
              '年龄',
              '票类型',
              '票价',
              '是否有座'
            ],
            [
              '<6岁',
              '儿童',
              '免费',
              '无座'
            ],
            [
              '6-14岁',
              '儿童',
              '优惠价',
              '有座'
            ],
            [
              '≥14岁',
              '成人',
              '全价',
              '有座'
            ],
          ]
        },
        {
          type: 'text',
          value: [{
            text: '· 儿童年龄按乘车日期计算'
          }]
        },
        {
          type: 'text',
          value: [{
            text: '· 每位成人'
          }, {
            text: '可免费携带1名0-6岁且不单独占用座位的儿童',
            highLight: true
          }, {
            text: '，如超过1名或儿童需要座位，需要购买儿童优惠票'
          }]
        },
        {
          type: 'text',
          value: [{
            text: '· 如儿童未办理身份证，可输入'
          }, {
            text: '户口本上的身份证号',
            highLight: true
          }, {
            text: '，携带户口本检票进站乘车'
          }]
        },
        {
          type: 'text',
          value: [{
            text: '· 中老铁路儿童票，须按儿童身高购买。身高1.2m~1.5m的未成年人可购买儿童票。每一名持票成年人旅客可免费携带一名身高不足1.2m且不单独占用席位的未成年人乘车，超过一名时，超过人数应购买儿童票。'
          }]
        },
      ]
    },
    props: {
      
    },
    computed: {

    },
    methods: {
      jumpToComment() {
        innerRouter.push(pagePath().ICKETPURCHASENOTICE, {
          checkTabIndex: 'child'
        })
      }
    }
  })
</script>

<style lang='stylus' scoped>
.child-card
  &-list
    margin-top 12px
  &-title
    display flex
    align-items center
    justify-content space-between
  &-more
    display flex
    align-items center
    font-weight 400
    font-size 12px
  &-text
    color #666
    font-size 14px
    margin-bottom 12px
    line-height 18px
    word-break break-all
    &-highlight
      color #FF7D41
  &-table
    border 1px solid rgba(0, 0, 0, 0.08)
    border-radius 6px
    margin-bottom 12px
    &-item
      display flex
      height 32px
      line-height 32px
      border-bottom 1px solid rgba(0, 0, 0, 0.08)
      &:last-child
        border-bottom 0
  &-th
    background rgba(231, 241, 255, 0.3)
    font-family PingFangSC-Medium
  &-tr
    font-family PingFangSC-Regular
  &-vItem
    font-size 12px
    border-right 1px solid rgba(0, 0, 0, 0.08)
    border-collapse collapse
    padding 8px 0 8px 12px
    display flex
    align-items center
    color #666
    &:nth-child(1)
      flex 1.7
    &:nth-child(2)
      flex 1
    &:nth-child(3)
      flex 1
    &:last-child
      flex 1.2
      border-right 0
  
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-card': '@didi/es-mpx-ui/lib/card',
    }
  }
</script>

